import { SafePaddingContainer } from "@/components/SafePaddingContainer";
import { SecondaryHeader } from "@/components/SecondaryHeader";
import { Button } from "@/components/ui/button";
import { openUrl } from "@/bridge/openUrl";
import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";
import { getFullStateName } from "@/helpers/getFullStateName";
import {
    show as showIntercomOverlay,
  } from "@intercom/messenger-js-sdk";

export function AboutUsPage() {
    const [isLocationAllowed] = useIsLocationAllowed();
    

    return (
        <div className="flex flex-col h-screen overflow-y-scroll pb-10 bg-white">
        <SafePaddingContainer orientation='header' className='bg-blue'>
            <SecondaryHeader text={'About us'} />
            {/* Main content */}
        </SafePaddingContainer>
        <SafePaddingContainer orientation='footer' className='bg-white'>
            <div className="p-4 max-w-md mx-auto mt-6">
                <div className='mb-8'>
                    <h2 className="text-3xl font-bold text-blue-dark mb-5">Hi Scratchers</h2>
                    <p className="text-blue-dark mb-6 text-md">
                        {`Scratch is the official provider for Skills-Based Scratch Off Cards in ${getFullStateName(isLocationAllowed?.locationName ?? 'PA')}.`}
                    </p>
                    <p className="text-blue-dark mb-6 text-md">
                        The Scratch app makes it easy to play cards and win real money, all from your mobile phone.
                    </p>
                    <p className="text-blue-dark mb-6 text-md">
                        Winnings are delivered instantly to your wallet and you’ll always stay anonymous, no matter how big of a win you get. 
                        A portion of every card pack goes to fund meals for students. 
                    </p>
                    <p className="text-blue-dark mb-6 text-md">
                        Scratch offers friendly 24/7 support and takes compliance seriously, with robust statistical analysis and mandatory geo-compliance at all times.
                    </p>
                    <p className="text-blue-dark mb-3 text-md">
                        Anything we can do to help?                    
                    </p>
                    <Button variant='wallet-btn' size='lg' className="bg-blue-dark text-white" shine
                        onClick={() => {
                            showIntercomOverlay();
                        }}>
                        Get help
                    </Button>
                </div>
                <div className='mb-8 text-blue-dark text-sm flex flex-col gap-3'>
                    <div className="flex flex-row gap-4">
                        {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                        <span className='hover:underline' onClick={() => openUrl('https://skillscratch.com/legal/terms')}>Terms of Use</span>
                        {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                        <span className='hover:underline' onClick={() => openUrl('https://skillscratch.com/legal/privacy')}>Privacy Policy</span>
                    </div>
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                    <span className='hover:underline' onClick={() => openUrl('https://skillscratch.com/legal/licensing')}>Prelicensing Agreement</span>
                </div>
            </div>
        </SafePaddingContainer>
    </div>
    );
}